// Module
var code = "<!-- ko if: showAccountLabel-->\r\n<span class=\"logo-caption\" data-bind=\"restext: accountTypeStringKey\"></span>\r\n<!-- /ko -->";
// Exports
export default code;